import { Spinner } from '@strata/react-loading-animation';
import PropTypes from 'prop-types';

import { ListPageHeader } from 'components/ListPageHeader';
import { Table } from 'components/Table';

export const List = ({
    pageTitle,
    columnNames,
    columnWidths = undefined,
    listData = undefined,
    isLoading = false,
    createPath = undefined,
    editPath = undefined,
    createButtonLabel = undefined,
    onCreateButtonClick = undefined,
    buttons = undefined,
    rightContent = undefined,
    keyFunction = undefined,
    rowClassName = undefined,
    defaultRowHeight = undefined,
    initialSort = undefined,
}) => (
    <div className="sds_main-content__container">
        <ListPageHeader
            pageTitle={pageTitle}
            rightContent={rightContent}
            buttons={[
                ...(createButtonLabel
                    ? [{ label: createButtonLabel, path: createPath, onClick: onCreateButtonClick }]
                    : []),
                ...(buttons ?? []),
            ]}
        />
        {isLoading ? (
            <div className="sds_loading_spinner">
                <Spinner size={Spinner.Size.LARGE} />
            </div>
        ) : (
            <Table
                columnNames={columnNames}
                columnWidths={columnWidths}
                tableData={listData}
                editPath={editPath}
                keyFunction={keyFunction}
                rowClassName={rowClassName}
                defaultRowHeight={defaultRowHeight}
                initialSort={initialSort}
            />
        )}
    </div>
);

List.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    columnNames: PropTypes.arrayOf(PropTypes.node).isRequired,
    columnWidths: PropTypes.arrayOf(PropTypes.number),
    listData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)),
    isLoading: PropTypes.bool,
    createPath: PropTypes.string,
    editPath: PropTypes.string,
    createButtonLabel: PropTypes.string,
    onCreateButtonClick: PropTypes.func,
    buttons: ListPageHeader.propTypes.buttons,
    rightContent: ListPageHeader.propTypes.rightContent,
    keyFunction: PropTypes.func,
    rowClassName: PropTypes.func,
    defaultRowHeight: PropTypes.number,
    initialSort: PropTypes.shape({}),
};
